import React from 'react';
import fbLogo from '../assets/partners/fb-logo.png';
import instaLogo from '../assets/partners/insta-logo.png';
import sioltaLogo from '../assets/partners/siolta.jpg';
import first5Logo from '../assets/partners/first5-logo.png';
import betterStartLogo from '../assets/partners/BETTER-START.png';
import tuslaLogo from '../assets/partners/Tusla-stacked-full-colour.png';
import aistearLogo from '../assets/partners/aistear-logo.png';
import pobalLogo from '../assets/partners/pobal-logo.png';
import eciLogo from '../assets/partners/eci-logo.webp';

interface Partner {
  name: string;
  logoUrl: string;
  link?: string;
}

const PartnerLogo: React.FC<{ partner: Partner }> = ({ partner }) => {
  const content = (
    <div className="flex items-center justify-center h-20 w-full">
      <img
        src={partner.logoUrl}
        alt={partner.name}
        className="max-w-full max-h-20 object-contain"
      />
    </div>
  );

  if (partner.link) {
    return (
      <a
        href={partner.link}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center p-4 hover:opacity-80 transition-opacity"
      >
        {content}
      </a>
    );
  }

  return (
    <div className="flex items-center justify-center p-4 hover:opacity-80 transition-opacity">
      {content}
    </div>
  );
};

export const Partners = () => {
  const partners: Partner[] = [
    {
      name: 'Facebook',
      logoUrl: fbLogo,
      link: 'https://www.facebook.com/childsplay.preschool.1/'
    },
    {
      name: 'Instagram',
      logoUrl: instaLogo,
      link: 'https://www.instagram.com/childsplay586/'
    },
    {
      name: 'síolta',
      logoUrl: sioltaLogo,
      link: 'https://www.siolta.ie/'
    },
    {
      name: 'First 5',
      logoUrl: first5Logo,
      link: 'https://www.gov.ie/en/department-of-children-disability-and-equality/campaigns/first-5/?referer=https://first5.gov.ie/'
    },
    {
      name: 'Better Start',
      logoUrl: betterStartLogo,
      link: 'https://www.betterstart.ie/'
    },
    {
      name: 'TUSLA',
      logoUrl: tuslaLogo,
      link: 'https://www.tusla.ie/'
    },
    {
      name: 'Aistear',
      logoUrl: aistearLogo,
      link: 'https://www.curriculumonline.ie/early-childhood/aistear-2024/'
    },
    {
      name: 'pobal',
      logoUrl: pobalLogo,
      link: 'https://www.pobal.ie/'
    },
    {
      name: 'early childhood ireland',
      logoUrl: eciLogo,
      link: 'https://www.earlychildhoodireland.ie/'
    }
  ];

  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="body-container">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 md:gap-8 items-center">
          {partners.map((partner, index) => (
            <PartnerLogo key={index} partner={partner} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;

